module.exports = __webpack_public_path__ + "img/logo.fdef7129.svg";